import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.0623 25.9791H22.0207V20.5364H25.979V25.9791H29.9373V16.5781L23.9998 12.6198L18.0623 16.5781V25.9791ZM23.9998 43.7916C18.6891 39.2726 14.7225 35.0751 12.1001 31.1992C9.4777 27.3233 8.1665 23.7361 8.1665 20.4375C8.1665 15.4896 9.75808 11.5477 12.9412 8.61196C16.1244 5.6762 19.8106 4.20831 23.9998 4.20831C28.1891 4.20831 31.8753 5.6762 35.0584 8.61196C38.2416 11.5477 39.8332 15.4896 39.8332 20.4375C39.8332 23.7361 38.522 27.3233 35.8996 31.1992C33.2772 35.0751 29.3106 39.2726 23.9998 43.7916Z",
		fill: "url(#paint0_linear_1355_4039)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_1355_4039",
		x1: 7.99988,
		y1: 44.3125,
		x2: 49.8174,
		y2: 22.5674,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedHome;
